<template>
    <div class="page_container" style="height: 100%;overflow-y: auto;padding:10px">
        <el-row style="height: 100%;" :gutter="20">
            <el-col :span="20">
                <div style="display: flex;align-items: center;">
                    <div style="flex: 1;">
                        <el-tabs v-model="activeTab" v-if="energyTypes.length > 1">
                            <el-tab-pane v-for="energyType in energyTypes" :label="getEnergyName(energyType)"
                                :name="energyType.toString()" :key="energyType"></el-tab-pane>

                        </el-tabs>
                    </div>
                    <div style="display: flex;align-items: center;">
                        <el-radio-group v-model="activeDateTab" size="mini" style="margin-right: 8px;">
                            <el-radio-button :label="1">{{ $t('龙翼简报.日') }}</el-radio-button>
                            <el-radio-button :label="2">{{ $t('龙翼简报.月') }}</el-radio-button>
                        </el-radio-group>
                        <el-date-picker size="mini" style="width: 150px;" v-show="activeDateTab == 1" v-model="queryDay"
                            type="date" :picker-options="datePickerOptions" :placeholder="$t('龙翼简报.选择日期')">
                        </el-date-picker>
                        <el-date-picker size="mini" style="width: 150px;" v-show="activeDateTab == 2"
                            v-model="queryMonth" type="month" :picker-options="monthPickerOptions"
                            :placeholder="$t('龙翼简报.选择月份')">
                        </el-date-picker>
                    </div>

                </div>
                <el-divider></el-divider>
                <div>
                    <div style="padding:12px 16px;display: flex;align-items: center;margin-bottom: 10px;">
                        <img src="../../assets/images/icon_yunying.png" alt="" style="width: 20px;height: 20px;">
                        <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.运营简报') }}</span>


                    </div>
                    <div v-loading="loading"
                        style="background: #E8F0FF;border-radius: 2px;border: 1px solid #D9E4F8;padding:50px;display: flex;align-items: center;justify-content: space-between;">
                        <IconDataItem :icon="require('@/assets/images/icon_total_vehicle.png')" :title="$t('龙翼简报.车辆总数')"
                            :value="operationReport.TotalCount" extValue="" />
                        <IconDataItem :icon="require('@/assets/images/icon_running.png')" :title="$t('龙翼简报.行驶')"
                            :value="operationReport.DriveCount" :extValue="operationReport.DrivePercent + '%'" />
                        <IconDataItem :icon="require('@/assets/images/icon_stop.png')" :title="$t('龙翼简报.停驶')"
                            :value="operationReport.StopCount" :extValue="operationReport.StopPercent + '%'" />

                        <IconDataItem :icon="require('@/assets/images/icon_offline.png')" :title="$t('龙翼简报.离线')"
                            :value="operationReport.OffLineCount" :extValue="operationReport.OffLinePercent + '%'"
                            color="#666666" />

                        <IconDataItem v-if="activeTab == '5'" :icon="require('@/assets/images/icon_rechargin.png')"
                            isRealData :title="$t('龙翼简报.充电')" :value="operationReport.ChargeCount"
                            :extValue="operationReport.ChargePercent + '%'" color="#07B477" />


                        <IconDataItem :icon="require('@/assets/images/icon_fault.png')" isRealData
                            :title="$t('龙翼简报.故障')" :value="operationReport.FailureCount"
                            :extValue="operationReport.FailurePercent + '%'" color="#FF106E" />

                    </div>
                </div>
                <div>
                    <div
                        style="padding:12px 16px;display: flex;align-items: center;margin-bottom: 0px;margin-top: 10px;">
                        <img src="../../assets/images/icon_yunying.png" alt="" style="width: 20px;height: 20px;">
                        <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.代办事项') }}</span>

                    </div>
                    <div v-loading="loading">
                        <el-row :gutter="20">
                            <el-col :span="6" v-if="FailureCount > 0"> <!---->
                                <ToDoItem :title="$t('龙翼简报.车辆故障')" :desc="$t('龙翼简报.车辆故障')" @click="handleFailureClick"
                                    :value="FailureCount"
                                    :moreValue="[FailureData.FailureRank.Rank3, FailureData.FailureRank.Rank2, FailureData.FailureRank.Rank1]" />
                            </el-col>

                            <el-col :span="6" v-if="HighConsumeData.Count > 0">
                                <ToDoItem :title="$t('龙翼简报.高能耗')" type="circle" :desc="$t('龙翼简报.当日高耗能车辆')"
                                    @click="handleHighConsumeClick"
                                    :value="HighConsumeData.Count + '/' + operationReport.TotalCount"
                                    :chartData="{ percent: HighConsumePercent, total: operationReport.TotalCount }" />

                            </el-col>
                            <el-col :span="6" v-if="InspectionData.Count > 0">
                                <ToDoItem :title="$t('龙翼简报.巡检异常')" @click="handleInspectionDataClick"
                                    :desc="$t('龙翼简报.昨日巡检异常车辆')" :value="InspectionData.Count" />

                            </el-col>
                            <el-col :span="6" v-if="DrivingData.Count > 0">
                                <ToDoItem :title="$t('龙翼简报.驾驶行为差')" @click="handleDrivingDataClick" type="circle"
                                    :desc="$t('龙翼简报.昨日驾驶评分低的车辆')"
                                    :value="DrivingData.Count + '/' + DrivingData.TotalCount"
                                    :chartData="{ percent: DrivingDataPercent, total: DrivingData.TotalCount }" />

                            </el-col>

                            <el-col :span="6" v-if="MaintainData.Count > 0">
                                <ToDoItem :title="$t('龙翼简报.维修中')" type="circle" :desc="$t('龙翼简报.维修中的车辆')"
                                    @click="handleMaintainDataClick"
                                    :value="MaintainData.Count + '/' + MaintainData.TotalCount"
                                    :chartData="{ percent: MaintainDataPercent, total: MaintainData.TotalCount }" />


                            </el-col>
                            <el-col :span="6" v-if="LongStayData.Count > 0">
                                <ToDoItem :title="$t('龙翼简报.长期未联网')" @click="handleLongStayDataClick" type="circle"
                                    :desc="$t('龙翼简报.长期未联网的车辆')"
                                    :value="LongStayData.Count + '/' + LongStayData.TotalCount"
                                    :chartData="{ percent: LongStayDataPercent, total: LongStayData.TotalCount }" />

                            </el-col>
                            <el-col :span="6" v-if="(activeTab == '1' || activeTab == '3') && LowOilData.Count > 0">
                                <ToDoItem :title="$t('龙翼简报.低油量')" type="circle" :desc="$t('龙翼简报.油量低于')"
                                    @click="handleLowOilDataClick"
                                    :value="LowOilData.Count + '/' + LowOilData.TotalCount"
                                    :chartData="{ percent: LowOilDataPercent, total: LowOilData.TotalCount }" />

                            </el-col>
                            <el-col :span="6" v-if="activeTab == '5' && LowBetteryData.Count > 0">
                                <ToDoItem :title="$t('龙翼简报.低电量')" type="circle" @click="handleLowBetteryDataClick"
                                    :desc="$t('龙翼简报.电量低于')"
                                    :value="LowBetteryData.Count + '/' + LowBetteryData.TotalCount"
                                    :chartData="{ percent: LowBetteryDataPercent, total: LowBetteryData.TotalCount }" />
                            </el-col>
                            <!-- <el-col :span="6" v-if="(activeTab == '2'||activeTab == '4'||activeTab == '6') && LowBetteryData.Count > 0">
                                <ToDoItem :title="$t('龙翼简报.低气量')" type="circle" @click="handleLowBetteryDataClick"
                                    :desc="$t('龙翼简报.气量低于')"
                                    :value="LowBetteryData.Count + '/' + LowBetteryData.TotalCount"
                                    :chartData="{ percent: LowBetteryDataPercent, total: LowBetteryData.TotalCount }" />
                            </el-col> -->
                        </el-row>

                    </div>
                </div>
                <div>
                    <div
                        style="padding:12px 16px;display: flex;align-items: center;margin-bottom: 10px;margin-top: 10px;">
                        <img src="../../assets/images/icon_yunying.png" alt="" style="width: 20px;height: 20px;">
                        <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.运营分析') }}</span>
                        <span style="color: #999999;font-size: 14px;" v-show="activeDateTab == 1">({{
                            $t('龙翼简报.近7日') }})</span>
                        <span style="color: #999999;font-size: 14px;" v-show="activeDateTab == 2">({{
                            $t('龙翼简报.近7月') }})</span>
                    </div>

                    <div class="chart-wrapper" style="position: relative;">
                        <div style="text-align: center;position: absolute;left: 39%;z-index: 999;top: 0%;">
                            <el-radio-group v-model="currentTab" size="small">
                                <el-radio-button label="里程统计">{{ $t('龙翼简报.里程统计') }}</el-radio-button>
                                <el-radio-button label="能耗统计">{{ $t('龙翼简报.能耗统计') }}</el-radio-button>
                                <el-radio-button label="运营时长统计">{{ $t('龙翼简报.运营时长统计') }}</el-radio-button>
                            </el-radio-group>
                        </div>
                        <!-- ECharts 容器 -->
                        <div class="chart-container" ref="chart" style="width: 100%; height: 400px;"></div>
                    </div>

                </div>
            </el-col>
            <el-col :span="4" style="height: 100%;">
                <div class="notice-container">
                    <div style="background: #E8F0FF;padding:12px 16px;display: flex;align-items: center;">
                        <img src="../../assets/images/icon_announcement.png" alt="" style="width: 20px;height: 20px;">
                        <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.公告') }}</span>
                    </div>

                    <kl-empty v-if="noticeList.length == 0" :show-pic="false" />

                    <div class="notice-item" v-for="(item, index) in noticeList" :key="index">
                        <div @click="currentNotice = item; noticeDialogVisible = true;"
                            style="display: flex;align-items: center;cursor: pointer;">

                            <img v-if="item.mustRead == 1" src="../../assets/images/icon_dot_red.png"
                                style="width: 20px;height: 20px;" />
                            <img v-else src="../../assets/images/icon_dot_gray.png" style="width: 20px;height: 20px;" />
                            <!--长度限制，超出部分省略号-->
                            <span class="notice-text">{{ item.afficheTitle }}</span>
                        </div>
                        <div class="date">{{ formatDate(item.updateTime, 1) }}</div>
                    </div>

                </div>
                <div class="notice-container" style="margin-top: 20px;">
                    <div style="background: #E8F0FF;padding:12px 16px;display: flex;align-items: center;">
                        <img src="../../assets/images/icon_message.png" alt="" style="width: 20px;height: 20px;">
                        <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.消息') }}</span>

                    </div>
                    <div>
                        <!--两个标签，报警和保养提醒-->
                        <el-tabs v-model="activeReminderTab" type="card" stretch style="border-bottom: none;">
                            <el-tab-pane :label="$t('龙翼简报.报警')" name="alarm">
                                <div v-if="alarmList.length == 0" style="padding: 20px;">
                                    <kl-empty :show-pic="false" />
                                </div>
                                <div v-else>
                                    <div class="notice-item" v-for="(item, index) in alarmList" :key="index">
                                        <div style="display: flex;align-items: center;cursor: pointer;"
                                            @click="handleAlarmClick(item)">
                                            <img v-if="item.Failrelevel == '4'"
                                                src="../../assets/images/icon_dot_red.png"
                                                style="width: 20px;height: 20px;" />
                                            <img v-else src="../../assets/images/icon_dot_gray.png"
                                                style="width: 20px;height: 20px;" />
                                            <span class="notice-text">{{ item.Failure }}</span>
                                        </div>
                                        <div class="date">{{ item.FailureTimec }}</div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('龙翼简报.维保')" name="business">
                                <div v-if="businessList.length == 0" style="padding: 20px;">
                                    <kl-empty :show-pic="false" />
                                </div>
                                <div v-else>
                                    <div class="notice-item" v-for="(item, index) in businessList" :key="index">
                                        <div style="display: flex;align-items: center;cursor: pointer;"
                                            @click="handleBusinessClick(item)">
                                            <img src="../../assets/images/icon_dot_gray.png"
                                                style="width: 20px;height: 20px;" />
                                            <span class="notice-text"
                                                :title="$t('failure.vehicle') + ' ' + item.CarNo + ' ' + $t('maintenanceReminder.维保提醒')">{{
                                                    $t('failure.vehicle') }} {{ item.CarNo }} {{
                                                    $t('maintenanceReminder.维保提醒') }}</span>
                                        </div>
                                        <div class="date">{{ formatDate(item.UpdateTime) }}</div>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>

                    </div>

                </div>
            </el-col>
        </el-row>
        <el-dialog :title="currentNotice.afficheTitle" :visible.sync="noticeDialogVisible" width="600px">
            <el-divider></el-divider>
            <div style="padding:10px;">
                <div v-html="currentNotice.afficheContent">
                </div>
                <div style="text-align: right;">{{ formatDate(currentNotice.updateTime) }}</div>
            </div>

        </el-dialog>

        <el-dialog :title="$t('龙翼简报.故障列表')" :visible.sync="FailureListDialogVisible">
            <div style="max-height: 40vh;overflow: auto;">
                <el-divider></el-divider>
                <table-pagination :data="FailureData.FailureDetail" :page-size="failurePageSize"
                    :current-page.sync="failureCurrentPage" @page-change="handleFailurePageChange" size="small">
                    <el-table-column property="CarNo" :label="$t('vehicle.carNo')"></el-table-column>
                    <el-table-column property="GpsDateTime" :label="$t('failure.故障时间')">
                        <template slot-scope="scope">
                            {{ formatDate(scope.row.GpsDateTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column property="FailureDesc" :label="$t('failure.故障描述')"></el-table-column>
                    <el-table-column property="DealWay" :label="$t('failure.处理方式')"></el-table-column>
                    <el-table-column property="FailureReason" :label="$t('failure.故障原因')"></el-table-column>
                    <el-table-column property="FailureRank" :label="$t('failure.故障等级')"></el-table-column>
                    <el-table-column property="Position" :label="$t('failure.车辆位置')"></el-table-column>
                </table-pagination>
            </div>
        </el-dialog>
        <el-dialog :title="$t('龙翼简报.高能耗车辆')" :visible.sync="highConsumeDialogVisible">
            <div style="max-height: 40vh;overflow: auto;">
                <el-divider></el-divider>
                <table-pagination :data="HighConsumeData.HighConsumeDetail" :page-size="highConsumePageSize"
                    :current-page.sync="highConsumeCurrentPage" @page-change="handleHighConsumePageChange" size="small">
                    <el-table-column property="CarNo" :label="$t('vehicle.carNo')" align="center"></el-table-column>
                    <el-table-column property="DeviceNo" :label="$t('vehicle.DeviceNo')"
                        align="center"></el-table-column>
                    <el-table-column property="VehicleModel" :label="$t('vehicle.VehicleModel')"
                        align="center"></el-table-column>
                    <!--纯电-->
                    <template v-if="activeTab == '5'">
                        <el-table-column property="Consume" :label="$t('龙翼简报.百公里燃耗(kwh/100km)')" width="160"
                            align="center"></el-table-column>
                        <el-table-column property="Mileage" :label="$t('龙翼简报.里程(km)')" align="center"></el-table-column>
                        <el-table-column property="ElecConsume" :label="$t('龙翼简报.燃耗(kwh)')"
                            align="center"></el-table-column>
                    </template>
                    <!--燃油，油电-->
                    <template v-if="activeTab == '1' || activeTab == '3'">
                        <el-table-column property="Consume" :label="$t('龙翼简报.百公里燃耗(L/100km)')" width="160"
                            align="center"></el-table-column>
                        <el-table-column property="Mileage" :label="$t('龙翼简报.里程(km)')" align="center"></el-table-column>
                        <el-table-column property="ElecConsume" :label="$t('龙翼简报.燃耗(L)')"
                            align="center"></el-table-column>
                    </template>
                    <!--氢燃料,气体机，气电-->
                    <template v-if="activeTab == '2' || activeTab == '6' || activeTab == '4'">
                        <el-table-column property="Consume" :label="$t('龙翼简报.百公里燃耗(Kg/100km)')" width="160"
                            align="center"></el-table-column>
                        <el-table-column property="Mileage" :label="$t('龙翼简报.里程(km)')" align="center"></el-table-column>
                        <el-table-column property="ElecConsume" :label="$t('龙翼简报.燃耗(Kg)')"
                            align="center"></el-table-column>
                    </template>
                    <!-- 其他列定义 -->
                </table-pagination>



            </div>
        </el-dialog>
        <el-dialog :title="$t('龙翼简报.昨日巡检异常记录')" :visible.sync="inspectionDialogVisible">
            <div style="max-height: 40vh;overflow: auto;">
                <el-divider></el-divider>
                <table-pagination :data="InspectionData.InspectionDetail" :page-size="inspectionPageSize"
                    :current-page.sync="inspectionCurrentPage" @page-change="handleInspectionPageChange" size="small">
                    <el-table-column property="CarNo" :label="$t('vehicle.carNo')" align="center"></el-table-column>
                    <el-table-column property="InspectionTime" :label="$t('龙翼简报.巡检时间')"
                        align="center"></el-table-column>
                    <el-table-column property="Result" :label="$t('龙翼简报.巡检结果')" width="160"
                        align="center"></el-table-column>
                    <el-table-column property="IsExteriorInspection" :label="$t('龙翼简报.巡检类型')" width="160"
                        align="center">
                        <template slot-scope="scope">
                            {{ scope.row.IsExteriorInspection == 1 ? $t('龙翼简报.外观') : $t('龙翼简报.智能') }}
                        </template>
                    </el-table-column>
                    <el-table-column property="OperatorName" :label="$t('龙翼简报.巡检人')" align="center"></el-table-column>
                    <!-- 其他列定义 -->
                </table-pagination>


            </div>
        </el-dialog>
        <el-dialog :title="$t('龙翼简报.昨日驾驶行为差记录')" :visible.sync="drivingDataDialogVisible">
            <div style="max-height: 40vh;overflow: auto;">
                <el-divider></el-divider>
                <table-pagination :data="DrivingData.DrivingDetail" :page-size="drivingPageSize"
                    :current-page.sync="drivingCurrentPage" @page-change="handleDrivingPageChange" size="small">

                    <el-table-column property="CarNo" :label="$t('vehicle.carNo')" align="center"></el-table-column>
                    <el-table-column property="TheDate" :label="$t('龙翼简报.日期')" align="center">
                        <template slot-scope="scope">
                            <!--取前面日期-->
                            {{ scope.row.TheDate.split('T')[0] }}
                        </template>
                    </el-table-column>
                    <el-table-column property="Score" :label="$t('龙翼简报.得分')" align="center"></el-table-column>
                    <el-table-column property="RunMileage" :label="$t('龙翼简报.行驶里程(km)')"
                        align="center"></el-table-column>
                </table-pagination>
            </div>
        </el-dialog>
        <el-dialog :title="$t('龙翼简报.长期未联网车辆')" :visible.sync="longStayDataDialogVisible">
            <div style="max-height: 40vh;overflow: auto;">
                <el-divider></el-divider>
                <table-pagination :data="LongStayData.LongStayDetail" :page-size="longStayPageSize"
                    :current-page.sync="longStayCurrentPage" @page-change="handleLongStayPageChange" size="small">
                    <el-table-column property="CarNo" :label="$t('vehicle.carNo')" align="center"></el-table-column>
                    <el-table-column property="DeviceNo" :label="$t('vehicle.DeviceNo')"
                        align="center"></el-table-column>
                    <el-table-column property="VehicleModel" :label="$t('vehicle.VehicleModel')"
                        align="center"></el-table-column>
                    <el-table-column property="GpsDateTime" :label="$t('龙翼简报.最后上线时间')" align="center"></el-table-column>


                </table-pagination>
            </div>
        </el-dialog>

        <el-dialog :title="$t('龙翼简报.低油量车辆')" :visible.sync="lowOilDataDialogVisible">
            <div style="max-height: 40vh;overflow: auto;">
                <el-divider></el-divider>
                <table-pagination :data="LowOilData.LowOilDetail" :page-size="lowOilPageSize"
                    :current-page.sync="lowOilCurrentPage" @page-change="handleLowOilPageChange" size="small">
                    <el-table-column property="CarNo" :label="$t('vehicle.carNo')" align="center"></el-table-column>
                    <el-table-column property="DeviceNo" :label="$t('vehicle.DeviceNo')"
                        align="center"></el-table-column>
                    <el-table-column property="VehicleModel" :label="$t('vehicle.VehicleModel')"
                        align="center"></el-table-column>
                    <el-table-column property="OilValue" :label="$t('龙翼简报.剩余油量(L)')" align="center"></el-table-column>


                </table-pagination>
            </div>
        </el-dialog>

        <el-dialog :title="$t('龙翼简报.低电量车辆')" :visible.sync="lowBetteryDataDialogVisible">
            <div style="max-height: 40vh;overflow: auto;">
                <el-divider></el-divider>
                <table-pagination :data="LowBetteryData.LowBetteryDetail" :page-size="lowBetteryPageSize"
                    :current-page.sync="lowBetteryCurrentPage" @page-change="handleLowBetteryPageChange" size="small">
                    <el-table-column property="CarNo" :label="$t('vehicle.carNo')" align="center"></el-table-column>
                    <el-table-column property="DeviceNo" :label="$t('vehicle.DeviceNo')"
                        align="center"></el-table-column>
                    <el-table-column property="VehicleModel" :label="$t('vehicle.VehicleModel')"
                        align="center"></el-table-column>
                    <el-table-column property="SOC" :label="$t('龙翼简报.剩余电量(%)')" align="center"></el-table-column>

                </table-pagination>
            </div>
        </el-dialog>

        <el-dialog :title="$t('龙翼简报.维修中车辆')" :visible.sync="maintainDataDialogVisible">
            <div style="max-height: 40vh;overflow: auto;">
                <el-divider></el-divider>

                <table-pagination :data="MaintainData.MaintainDetail" :page-size="maintainPageSize"
                    :current-page.sync="maintainCurrentPage" @page-change="handleMaintainPageChange" size="small">
                    <el-table-column property="CarNo" :label="$t('vehicle.carNo')" align="center"></el-table-column>
                    <el-table-column property="DeviceNo" :label="$t('vehicle.DeviceNo')"
                        align="center"></el-table-column>
                    <el-table-column property="VehicleModel" :label="$t('vehicle.VehicleModel')"
                        align="center"></el-table-column>


                </table-pagination>
            </div>
        </el-dialog>
        <el-dialog :title="$t('龙翼简报.故障信息')" :visible.sync="alarmDialogVisible" width="40%">
            <div style="max-height: 40vh;overflow: auto;">
                <el-divider></el-divider>
                <!-- 显示单条故障的信息 -->
                <el-descriptions>
                    <el-descriptions-item :label="$t('vehicle.carNo')">{{ alarmInfo.CarNo }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('failure.故障等级')">{{ alarmInfo.Failrelevel }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('failure.故障描述')">{{ alarmInfo.Failure }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('failure.故障时间')">{{ alarmInfo.FailureTimec
                    }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('failure.故障类型')">{{ alarmInfo.FailureType }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('failure.车辆位置')">{{ alarmInfo.Location }}</el-descriptions-item>

                </el-descriptions>
                <!--  <div>
                    <KingLongMap  ref="map" @LoadCompleted="MapLoadCompleted" mapId="klmap_failureinfo"
                        style="height: 300px;width:100%" />

                </div>-->

            </div>
        </el-dialog>


        <MaintenanceDetailDialog :visible.sync="showDetail" :record="currentRecord" @close="handleDialogClose" />
    </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap"
import TablePagination from "@/components/TablePagination"

// import * as echarts from 'echarts'
import IconDataItem from "./components/IconDataItem"
import ToDoItem from "./components/ToDoItem"
import { topaffiche } from "@/http/vehicle";
import language from '@/utils/getLanguageId'
import settings from "@/settings";
import MaintenanceDetailDialog from '../maintenance/maintenanceReminder/MaintenanceDetailDialog.vue'
export default {
    name: "dashboard",
    components: { IconDataItem, ToDoItem, KingLongMap, TablePagination, MaintenanceDetailDialog },

    data() {
        return {
            datePickerOptions: {
                disabledDate(date) {
                    if (settings.supportTodayDataQuery) {
                        return date > new Date(new Date().getTime())
                    }
                    return date > new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
                }
            },
            monthPickerOptions: {
                disabledDate(date) {

                    var t = new Date();
                    var n = new Date(t.getFullYear(), t.getMonth(), 1);
                    if (settings.supportTodayDataQuery) {
                        return date > new Date(new Date().getTime())
                    }
                    return date > new Date(n.getTime() - 24 * 60 * 60 * 1000)
                }
            },
            loading: false,
            queryDay: "",
            queryMonth: "",
            beginDate_day: "",
            endDate_day: "",
            beginDate_month: "",
            endDate_month: "",
            activeTab: "3",
            oilType: 3,//1 柴油 2 气体机 3 油电 4 气电 5 纯电动 6 燃料电池
            activeDateTab: 1,
            queryDate: "",//示例：查询当日 2025-07-24 查询当月 2025-07
            queryDayDate: "",
            queryMonthDate: "",
            queryType: 1,//2:查月 1:查日

            LanguageId: 1,
            operationReport: {
                TotalCount: 0,//总车辆数
                DriveCount: 0,//行驶车辆数
                DrivePercent: 0.0,//行驶车辆占比
                StopCount: 0,//停驶车辆数
                StopPercent: 0.0,//停驶车辆占比
                OffLineCount: 0,//离线车辆数
                OffLinePercent: 0.0,//离线车辆占比
                ChargeCount: 0,//充电车辆数
                ChargePercent: 0.0,//充电车辆占比    
                FailureCount: 0,//故障车辆数
                FailurePercent: 0.0,//故障车辆占比
            },
            //故障数据
            FailureData: {
                //车辆故障数据
                "FailureRank": {
                    "Rank3": 0,
                    "Rank2": 0,
                    "Rank1": 0,
                    "FailureVCount": 0,
                    "FailurePercent": 0
                },
                FailureDetail: []
            },
            FailureListDialogVisible: false,
            failureCurrentPage: 1,
            failurePageSize: 10,

            HighConsumeData: {
                //高能耗
                "Count": 0,
                HighConsumeDetail: []
            },
            HighConsumePercent: 0.0,
            highConsumeDialogVisible: false,
            highConsumeCurrentPage: 1,
            highConsumePageSize: 10,
            //巡检数据
            InspectionData: {
                "Count": 0,
                "InspectionDetail": []
            },
            inspectionDialogVisible: false,
            inspectionCurrentPage: 1,
            inspectionPageSize: 10,

            //不良驾驶
            DrivingData: {
                "TotalCount": 0,
                "Count": 0,
                "DrivingDetail": []
            },
            DrivingDataPercent: 0.0,
            drivingDataDialogVisible: false,
            drivingCurrentPage: 1,
            drivingPageSize: 10,

            LongStayData: {
                "TotalCount": 0,
                "Count": 0,
                "LongStayDetail": []
            },
            LongStayDataPercent: 0.0,
            longStayDataDialogVisible: false,
            longStayCurrentPage: 1,
            longStayPageSize: 10,

            LowOilData: {
                "TotalCount": 0,
                "Count": 0,
                "LowOilDetail": []
            },
            LowOilDataPercent: 0.0,
            lowOilDataDialogVisible: false,
            lowOilCurrentPage: 1,
            lowOilPageSize: 10,


            LowBetteryData: {
                "TotalCount": 0,
                "Count": 0,
                "LowBetteryDetail": []
            },
            LowBetteryDataPercent: 0.0,
            lowBetteryDataDialogVisible: false,
            lowBetteryCurrentPage: 1,
            lowBetteryPageSize: 10,


            MaintainData: {
                "TotalCount": 0,
                "Count": 0,
                "MaintainDetail": []
            },
            MaintainDataPercent: 0.0,
            maintainDataDialogVisible: false,
            maintainCurrentPage: 1,
            maintainPageSize: 10,


            currentTab: '里程统计',

            chartDataMap: {
                '里程统计': {
                    xAxisData: [],
                    seriesData1: [], // 总里程
                    seriesData2: [], // 单车平均里程
                    yAxisName1: this.$t('龙翼简报.总里程(km)'),
                    yAxisName2: this.$t('龙翼简报.平均里程(km/车)'),
                    seriesNames: [this.$t('龙翼简报.总里程'), this.$t('龙翼简报.单车每日平均里程')]

                },
                '能耗统计': {
                    xAxisData: [],
                    seriesData1: [], // 总能耗
                    seriesData2: [], // 平均能耗
                    yAxisName1: this.$t('龙翼简报.总能耗') + '(kW·h)',
                    yAxisName2: this.$t('龙翼简报.平均能耗') + '(kW·h/' + this.$t('龙翼简报.车') + ')',

                    seriesNames: [this.$t('龙翼简报.总能耗'), this.$t('龙翼简报.单车每日平均能耗')]
                },
                '运营时长统计': {
                    xAxisData: [],
                    seriesData1: [], // 总运营时长
                    seriesData2: [], // 平均运营时长
                    yAxisName1: this.$t('龙翼简报.总时长(小时)'),
                    yAxisName2: this.$t('龙翼简报.平均时长(小时/车)'),
                    seriesNames: [this.$t('龙翼简报.总运营时长'), this.$t('龙翼简报.单车平均运营时长')]

                }
            },
            noticeList: [
            ],
            currentNotice: {
                afficheTitle: "",
                afficheContent: "",

            },
            noticeDialogVisible: false,
            alarmList: [
            ],
            alarmInfo: {},
            alarmDialogVisible: false,

            activeReminderTab: 'alarm',
            businessList: [

            ],


            timer: null,
            mapisload: false,
            cacheData: {},
            showDetail: false,
            currentRecord: {},

        }
    },
    computed: {

        // 能源类型清单
        energyTypes() {
            return this.$store.getters.energyTypes;
        },

        FailureCount() {
            return this.FailureData.FailureRank.Rank3 + this.FailureData.FailureRank.Rank2 + this.FailureData.FailureRank.Rank1;
        },
        //高能耗占比
        chartUnit() {
            if (this.currentTab == '里程统计') {
                return 'km';
            } else if (this.currentTab == '能耗统计') {
                return this.getUnit(this.oilType);


            } else if (this.currentTab == '运营时长统计') {
                return this.$t('time.hour');
            }
        }


    },
    mounted() {

        const currentPath = this.$route.path
        // 从全局变量中取出对应路由的开始时间
        const startTime = settings.routeStartTime[currentPath]
        if (startTime) {
            // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
            const renderTime = Date.now() - startTime
            console.log(`路由 ${currentPath} 渲染耗时：${renderTime}ms`)
            // 可选：上报到后端或日志系统
            // reportRenderTime(currentPath, renderTime)

            // 清除已计算的开始时间，避免重复计算
            delete settings.routeStartTime[currentPath]
        }

        this.LanguageId = language(this.$store.getters.locale)

        this.initChart();
        // 监听窗口大小变化，自适应图表
        window.addEventListener('resize', this.resizeChart);
        this.queryDay = this.moment().subtract(1, 'days').format('YYYY-MM-DD');
        this.queryMonth = this.moment().subtract(1, 'months').format('YYYY-MM');
        if (settings.supportTodayDataQuery) {
            this.queryDay = this.moment().subtract(0, 'days').format('YYYY-MM-DD');
            this.queryMonth = this.moment().subtract(0, 'months').format('YYYY-MM');
        }


        //默认的显示类型，如果只有一个的时候
        if (this.energyTypes.length > 0) {
            this.activeTab = this.energyTypes[0].toString();
        }
        // this.queryData();

        this.queryTopAffiche();

        this.queryFaultData();

        this.queryBusinessData();
        //增加定时器，10分钟一次，页面没用显示就先关闭
        this.timer = setInterval(() => {
            this.queryFaultData();
        }, 10 * 60 * 1000);

        this.$bus.$on("changeLang", (data) => {
            // console.log(data);
            this.showData(this.cacheData);
            //    this.resizeChart();
        });


        //判断用户上次密码修改时间，是否大于90天，如果大于90天，就提示用户修改密码，用户点击确认之后，进入到密码修改页面


        // console.log(this.$store.getters.operator.LastModifyPswTime);
// console.log(this.$store.getters.operator.GoogleMapInfo);
        if (this.$store.getters.operator.LastModifyPswTime) {
            let lastModifyTime = this.moment(this.$store.getters.operator.LastModifyPswTime);
            let now = this.moment();
            let diffDays = now.diff(lastModifyTime, 'days');
            if (diffDays > 90) {
                this.$confirm(this.$t("confirm.passwordExpire"), this.$t("public.tips"), {
                    confirmButtonText: this.$t("public.confirm"),
                    cancelButtonText: this.$t("public.cancel"),
                    type: "warning",
                })
                    .then(() => {
                        this.$router.push({
                            path: '/setting/changepsw',
                        });
                    })
                    .catch(() => { });

            }
        }


    },
    activated() {
        // 组件激活时重新初始化图表
        this.resizeChart();
    },
    beforeDestroy() {
        // 组件销毁前移除事件监听
        window.removeEventListener('resize', this.resizeChart);
        if (this.chart) {
            this.chart.dispose(); // 销毁图表实例
        }
        //清除定时器
        clearInterval(this.timer);
    },
    methods: {
        handleDialogClose() {
            this.currentRecord = {};
        },
        queryBusinessData() {

            this.$api.MaintananceSingleReminder({
                Vehicles: "",
                VehicleModel: "",
                Language: this.$store.getters.LanguageId,
                PageNo: 1,
                PageSize: 5,
                IsExport: 0,
                IsRead: 0,
            }, 'json').then(res => {
                if (res.code == 200) {
                    this.businessList = res.data;
                }
            });
        },
        getUnit(oilType) {

            switch (oilType) {
                case 1:
                case 3:
                    return 'L';
                case 5:
                    return 'kW·h';
                case 2:
                case 4:
                case 6:
                    return 'kg';
            }
        },

        getEnergyName(energyType) {
            if (energyType == 1) {
                return this.$t('oiltype.caiyouji');
            } else if (energyType == 2) {
                return this.$t('oiltype.qitiji');
            } else if (energyType == 3) {
                return this.$t('oiltype.youdain');
            } else if (energyType == 4) {
                return this.$t('oiltype.qidian');
            } else if (energyType == 5) {
                return this.$t('oiltype.chundiandong');
            } else if (energyType == 6) {
                return this.$t('oiltype.ranliao');
            }
            return '';
        },
        handleHighConsumePageChange(page) {
            this.highConsumeCurrentPage = page;
        },
        handleInspectionPageChange(page) {
            this.inspectionCurrentPage = page;
        },
        handleDrivingPageChange(page) {
            this.drivingCurrentPage = page;
        },
        handleLongStayPageChange(page) {
            this.longStayCurrentPage = page;
        },
        handleLowOilPageChange(page) {
            this.lowOilCurrentPage = page;
        },
        handleLowBetteryPageChange(page) {
            this.lowBetteryCurrentPage = page;
        },
        handleMaintainPageChange(page) {
            this.maintainCurrentPage = page;
        },
        handleFailurePageChange(page) {
            this.failureCurrentPage = page;
        },





        MapLoadCompleted() {
            this.mapisload = true;
            console.log("地图加载完成");
            if (this.alarmInfo && this.alarmDialogVisible) {
                this.showMapLocation();
            }
        },
        showMapLocation() {
            return;
            console.log("显示位置1");
            if (this.$refs.map && this.mapisload) {
                console.log("显示位置2");
                this.$refs.map.clearMarkers();
                console.log(this.alarmInfo);

                this.$refs.map.addMarker(
                    "v_1012",
                    this.alarmInfo.CarNo,
                    this.alarmInfo.Longitude,
                    this.alarmInfo.Latitude,
                    "assets/svgs/icon_loc_selected_270.svg"
                );
                // this.$refs.map.setCenter(this.alarmInfo.Longitude, this.alarmInfo.Latitude);
            }
        },

        handleAlarmClick(row) {
            //显示故障信息
            console.log(row);
            this.alarmInfo = row;
            this.alarmDialogVisible = true;

            this.$nextTick(() => {
                this.showMapLocation();
            });
        },
        handleBusinessClick(row) {
            //显示业务提醒详情
            console.log(row);
            this.currentRecord = { ...row };
            this.showDetail = true;

        },
        queryFaultData() {
            //故障数据查询，最近一个小时
            var startDate = this.moment().subtract(1, 'hours').format('YYYY-MM-DD HH:mm:ss');
            var endDate = this.moment().format('YYYY-MM-DD HH:mm:ss');


            this.$api.FailureInfo({
                StartDate: startDate,//startTime,//"2023-09-17",//startTime,
                EndDate: endDate,//endTime,//"2023-09-17",//endTime,
                // vehicles:this.vehicles,
                vehicles: "",//暂定只差全部车辆，后续确认
                OperatorID: this.$store.getters.operator.OperatorId,
                SubjectCorpID: this.$store.getters.operator.CompanyId,
                info: "",//这个是车号
                pageNo: 1,
                pageSize: 5,
                Language: this.LanguageId,
                IsExport: 0, // 0是查询 1是下载
            })
                .then((res) => {

                    if (res && res.code == 200) {
                        if (res.data)
                            this.alarmList = res.data;
                        else {
                            this.alarmList = [];
                        }

                    }
                }).catch((err) => {

                });
        },
        formatDate(time, isShort) {
            if (!time)
                return "";

            time = time.replace("T", " ");
            time = time.replace("Z", "");
            //只显示日期部分
            if (isShort && isShort == 1) {
                //只显示日期部分
                time = time.split(" ")[0];
                return time;
            }
            return time;
            // return this.moment(time).format('YYYY-MM-DD HH:mm:ss');

        },
        //查询顶部公告
        queryTopAffiche() {
            topaffiche({
                LanguageId: this.LanguageId
            }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    if (res.data)
                        this.noticeList = res.data;
                    else {
                        this.noticeList = [];
                    }
                }
            })
        },

        queryData() {

            this.loading = true;

            // this.queryDate = "2025-07-30";
            this.queryDate = this.queryDayDate;
            if (this.activeDateTab == 2) {
                this.queryDate = this.queryMonthDate;
                // this.queryDate = "2025-07";
            }
            if (this.queryDate == "") return;
            // console.log(this.queryDate);
            //查询数据，先查缓存 queryDate queryType oilType
            var key = this.queryDate + "_" + this.queryType + "_" + this.oilType;
            var data = null;// localStorage.getItem(key);//null;//
            // if (data) {
            //     data = JSON.parse(data);
            //     this.cacheData = data;
            //     this.showData(data);
            // } else {
            //缓存没有，查询接口

            this.$api.queryWebHomeOverview({
                queryDate: this.queryDate,
                queryType: this.queryType,
                oilType: this.oilType,//==6?2:this.oilType==5?3:this.oilType,
            }).then(res => {

                data = res;
                this.cacheData = data;
                this.showData(data);
                localStorage.setItem(key, JSON.stringify(data));
            })
            // }
        },
        showData(data) {
            console.log(data);
            this.loading = false;
            if (data) {
                //运营简报数据
                this.operationReport = data.operationReport;
                this.FailureData = data.pendingData.FailureData;
                this.HighConsumeData = data.pendingData.HighConsumeData;

                // console.log(((this.HighConsumeData.Count / this.operationReport.TotalCount) * 100))
                this.HighConsumePercent = ((this.HighConsumeData.Count / this.operationReport.TotalCount) * 100).toFixed(0);

                this.DrivingData = data.pendingData.DrivingData;
                this.DrivingDataPercent = ((this.DrivingData.Count / this.DrivingData.TotalCount) * 100).toFixed(0);

                this.LongStayData = data.pendingData.LongStayData;
                this.LongStayDataPercent = ((this.LongStayData.Count / this.LongStayData.TotalCount) * 100).toFixed(0);


                this.LowOilData = data.pendingData.LowOilData;
                this.LowOilDataPercent = ((this.LowOilData.Count / this.LowOilData.TotalCount) * 100).toFixed(0);

                this.LowBetteryData = data.pendingData.LowBetteryData;
                this.LowBetteryDataPercent = ((this.LowBetteryData.Count / this.LowBetteryData.TotalCount) * 100).toFixed(0);

                this.MaintainData = data.pendingData.MaintainData;
                this.MaintainDataPercent = ((this.MaintainData.Count / this.MaintainData.TotalCount) * 100).toFixed(0);

                //oilType: 3,//1:柴油 2：气体机 3：纯电
                this.chartDataMap = {
                    '里程统计': {
                        xAxisData: [],
                        seriesData1: [], // 总里程
                        seriesData2: [], // 单车平均里程
                        yAxisName1: this.$t('龙翼简报.总里程(km)'),
                        yAxisName2: this.$t('龙翼简报.平均里程(km/车)'),
                        seriesNames: [this.$t('龙翼简报.总里程'), this.$t('龙翼简报.单车每日平均里程')]
                    },
                    '能耗统计': {
                        xAxisData: [],
                        seriesData1: [], // 总能耗
                        seriesData2: [], // 平均能耗
                        yAxisName1: this.$t('龙翼简报.总能耗') + '(' + this.getUnit(this.oilType) + ')',


                        yAxisName2: this.$t('龙翼简报.平均能耗') + '(' + this.getUnit(this.oilType) + '/' + this.$t('龙翼简报.车') + ')',




                        seriesNames: [this.$t('龙翼简报.总能耗'), this.$t('龙翼简报.单车每日平均能耗')]

                    },
                    '运营时长统计': {
                        xAxisData: [],
                        seriesData1: [], // 总运营时长
                        seriesData2: [], // 平均运营时长
                        yAxisName1: this.$t('龙翼简报.总时长(小时)'),
                        yAxisName2: this.$t('龙翼简报.平均时长(小时/车)'),
                        seriesNames: [this.$t('龙翼简报.总运营时长'), this.$t('龙翼简报.单车平均运营时长')]
                    }
                };

                //数据反转
                if (data.operationAnalysis.MileageStat && data.operationAnalysis.MileageStat.length > 0) {
                    data.operationAnalysis.MileageStat.reverse();
                    data.operationAnalysis.MileageStat.forEach(element => {
                        this.chartDataMap['里程统计'].xAxisData.push(element.TheDate);
                        this.chartDataMap['里程统计'].seriesData1.push(element.TotalMileage);
                        this.chartDataMap['里程统计'].seriesData2.push(element.AvgMileage);

                    });
                }
                if (data.operationAnalysis.ConsumeStat && data.operationAnalysis.ConsumeStat.length > 0) {
                    data.operationAnalysis.ConsumeStat.reverse();
                    data.operationAnalysis.ConsumeStat.forEach(element => {
                        this.chartDataMap['能耗统计'].xAxisData.push(element.TheDate);
                        this.chartDataMap['能耗统计'].seriesData1.push(element.TotalConsume);
                        this.chartDataMap['能耗统计'].seriesData2.push(element.AvgConsume);

                    });
                }
                if (data.operationAnalysis.DurationStat && data.operationAnalysis.DurationStat.length > 0) {
                    data.operationAnalysis.DurationStat.reverse();
                    data.operationAnalysis.DurationStat.forEach(element => {
                        this.chartDataMap['运营时长统计'].xAxisData.push(element.TheDate);
                        //把秒转换成小时
                        element.TotalDuration = (element.TotalDuration / 3600).toFixed(2);
                        element.AvgDuration = (element.AvgDuration / 3600).toFixed(2);
                        this.chartDataMap['运营时长统计'].seriesData1.push(element.TotalDuration);
                        this.chartDataMap['运营时长统计'].seriesData2.push(element.AvgDuration);

                    });
                }
                this.renderChart();

            }
        },
        handleFailureClick() {
            this.FailureListDialogVisible = true;
        },
        handleHighConsumeClick() {
            this.highConsumeDialogVisible = true;
        },
        handleInspectionDataClick() {
            this.inspectionDialogVisible = true;
        },
        handleDrivingDataClick() {
            this.drivingDataDialogVisible = true;
        },
        handleLongStayDataClick() {
            this.longStayDataDialogVisible = true;
        },
        handleLowOilDataClick() {
            this.lowOilDataDialogVisible = true;
        },
        handleLowBetteryDataClick() {
            this.lowBetteryDataDialogVisible = true;
        },
        handleMaintainDataClick() {
            this.maintainDataDialogVisible = true;
        },

        initChart() {
            this.chart = echarts.init(this.$refs.chart);
            this.renderChart();

        },
        renderChart() {
            const data = this.chartDataMap[this.currentTab];
            const option = {
                // backgroundColor: '#fff',
                title: {
                    // text: this.currentTab,
                    left: 'center',
                    textStyle: {
                        color: '#333',
                        fontWeight: 'normal'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    borderColor: '#eee',
                    borderWidth: 1,
                    textStyle: { color: '#333' },
                    formatter: (params) => {
                        let tip = `<div style="font-weight: bold;">${params[0].name}</div>`;
                        // var unit="km"
                        params.forEach(item => {
                            tip += `<div style="color:${item.color}">● ${item.seriesName}: ${item.value} ${this.chartUnit}</div>`;

                        });
                        return tip;
                    }
                },
                legend: {
                    data: data.seriesNames,
                    type: 'scroll',
                    bottom: '5%',
                    pageButtonItemGap: 5,
                    pageButtonStyle: { color: '#666' }
                },
                grid: {
                    left: '3%',
                    right: '8%',
                    bottom: '15%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: data.xAxisData,
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: { color: '#999' }
                    },
                    axisLabel: {
                        color: '#0F1A3A',
                        interval: 0,
                        rotate: 0
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: data.yAxisName1,
                        axisTick: { show: false },
                        axisLine: {
                            lineStyle: { color: '#999' }
                        },
                        axisLabel: { color: '#666' },
                        splitLine: {
                            lineStyle: {
                                color: '#eee',
                                type: 'dashed'
                            }
                        }
                    },
                    {
                        type: 'value',
                        name: data.yAxisName2,
                        axisTick: { show: false },
                        axisLine: {
                            lineStyle: { color: '#999' }
                        },
                        axisLabel: { color: '#666' },
                        splitLine: { show: false },
                        position: 'right'
                    }
                ],
                series: [
                    {
                        name: data.seriesNames[0],
                        type: 'bar',
                        data: data.seriesData1,
                        yAxisIndex: 0,
                        barWidth: 15,
                        itemStyle: {
                            borderRadius: [2, 2, 0, 0],
                            color: '#2A7AFF'
                        }
                    },
                    {
                        name: data.seriesNames[1],
                        type: 'line',
                        data: data.seriesData2,
                        yAxisIndex: 1,
                        symbol: 'circle',
                        symbolSize: 8,
                        itemStyle: { color: '#07B477' },
                        lineStyle: { width: 2, color: '#07B477' },

                    }
                ]
            };

            this.chart.setOption(option);
        },

        resizeChart() {
            if (this.chart) {
                this.chart.resize();
            }
        },
        initMonthDate() {
            var date = new Date();
            if (!(this.queryMonth instanceof Date)) {
                date = new Date(this.queryMonth);
            } else {
                date = this.queryMonth;
            }
            var now = this.moment(date);
            this.queryMonthDate = now.format('YYYY-MM');
        },
        initDayDate() {
            var date = new Date();
            if (!(this.queryDay instanceof Date)) {
                date = new Date(this.queryDay);
            } else {
                date = this.queryDay;
            }
            var now = this.moment(date);
            this.queryDayDate = now.format('YYYY-MM-DD');
        },


    },
    watch: {
        activeTab(newVal, oldVal) {
            this.oilType = parseInt(newVal);

            this.queryData();

        },
        activeDateTab(newVal, oldVal) {
            this.queryType = newVal;
            //切换日期
            if (newVal == 1) {
                this.initDayDate();

            } else {

                this.initMonthDate();

            }
            this.queryData();
        },

        currentTab() {
            this.renderChart();
        },
        queryDay() {
            this.initDayDate();
            this.queryData();


        },
        queryMonth() {
            this.initMonthDate();
            this.queryData();

        }
    }
}
</script>
<style scoped>
.chart-wrapper {
    width: 100%;
    margin: 0 auto;
    /* padding: 20px; */
    /* background-color: #fff; */
    /* border-radius: 4px; */
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.chart-container {
    margin-top: 20px;
}

.notice-container {
    border: 1px solid #C5D0E2;
    width: 100%;
    height: 50%;
    min-height: 320px;
    /* 可根据实际调整宽度 */
}

.notice-item {
    padding-top: 8px;
    padding-left: 16px;
    padding-bottom: 8px;
}

.dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
}

.red-dot {
    background-color: red;
}

.gray-dot {
    background-color: gray;
}

.notice-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
}

.date {
    font-size: 12px;
    padding-top: 4px;
    margin-left: 20px;
    color: #0E193B;
}

.el-col {
    margin-top: 20px;
}
</style>